module.exports = __webpack_public_path__ + "static/device-1-854c3d18bc92807151af58a75910dde9.webp";